/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Card, CardBody, Row, Col, Label } from "reactstrap";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import ButtonComponent from "../../../../components/ButtonComponent";
import Select from "react-select";
import {
  useCreateSetMenuMutation,
  useUploadSetMenuLogoFileExtntionHttpsMutation,
  useLazyGetMenuItemListQuery,
} from "../../../../redux/services/setMenuService";
import { toast } from "react-toastify";
import { Button, CardHeader, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import IMGUploadComponent from "../../../../components/IMGUploadComponent";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import { CreateSetMenuRequest } from "../../../../redux/setMenuSlice";
import { uploadImage } from "../../../../components/imageUploadCompont";
import {
  capitalizeFirstLetter,
  customFilterOption,
} from "../../../../utility/Utility";
import { DEFAULT_IMAGE_URL } from "../../../../constants/constans";
import ControlledRowTextFieldForPortion from "../../../../components/RowTextFieldsForPortions";
import ControlledSelect from "../../../../components/ControlledSelect";
import { useSelector } from "react-redux";
import {
  useGetAllergenInformationQuery,
  useGetFoodAttributesListQuery,
  useLazyGetRestaurantFilterTagsQuery,
} from "../../../../redux/services/menuItemService";
import ControlledRowSelectPortion from "../../../../components/ControlledRowSelectPortion";
import { useLazyGetPortionSizesQuery } from "../../../../redux/services/CustomTypeService";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";
import React from "react";

export const portionSizes = [
  { value: "small", label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Large" },
];

const AddMenu = () => {
  const navigate = useNavigate();
  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  const reastaurantData = useSelector(
    (state: any) => state?.restaurant?.selectedRestaurantDetails
  );

  // Initial form values
  const defaultValues = {
    restaurantId: RestID,
    items: [],
    description: "",
    displayName: "",
    abbreviation: "",
    imageReference: "",
    category: "",
    imageUrl: "",
    allergenInformation: [],
    foodAttributes: [],
    supportPortionSizes: false,
    portions: [],
    portionSize: "",
    portionPrice: "",
    filterTags: [],
    productId: "",
    supportsPreOrdering: false,
    tinyId: 0,
  };

  // Form handling
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<CreateSetMenuRequest>({
    defaultValues,
  });

  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [quantity, setQuantity] = useState<number>(1);
  const [canPortion, setCanPortion] = useState(false);
  const [portionSize, setPortionSize] = useState("");
  const [portionPrice, setPortionPrice] = useState("");
  const [portions, setPortions] = useState<
    { size: string; additionalCost: number }[]
  >([]);
  const [portionErrorMessage, setPortionErrorMessage] = useState<string | null>(
    null
  );
  const [availableOptions, setAvailableOptions] = useState<any[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const [uploadedImgDetails, setUploadedImgDetails] = useState({
    imgSrc: "",
    formData: "",
    fileExtention: "",
  });
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isPreOrder, setIsPreOrder] = useState(false);

  const [createSetMenu] = useCreateSetMenuMutation();
  const [uploadLogoFileExtetion] =
    useUploadSetMenuLogoFileExtntionHttpsMutation();
  const [triggerGetMenuItemList, { isLoading, data: menuItemsData }] =
    useLazyGetMenuItemListQuery();
  const [triggerGetPortionSizes, { data: portionSizesData = [] }] =
    useLazyGetPortionSizesQuery();
  const { data: foodAttributesData } = useGetFoodAttributesListQuery();
  const [isPortionPriceDisable, setIsPortionPriceDisable] =
    useState<boolean>(false);
  useEffect(() => {
    if (RestID) {
      triggerGetPortionSizes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetPortionSizes]);

  const [
    triggerGetFilterTags,
    { data: filterTagsData, isLoading: isFilterTagsLoading },
  ] = useLazyGetRestaurantFilterTagsQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetFilterTags(RestID);
    }
  }, [RestID, triggerGetFilterTags]);

  const filterTagsOptions = React.useMemo(() => {
    if (isFilterTagsLoading || !filterTagsData) return [];

    const options: { value: string; label: string }[] = [];

    // Iterate over each category in filterTags
    Object.entries(filterTagsData.filterTags).forEach(
      ([category, categoryData]) => {
        if (categoryData.tags && Array.isArray(categoryData.tags)) {
          categoryData.tags.forEach((tag) => {
            if (tag.show) {
              options.push({ value: tag.tag, label: `${tag.tag}` });
            }
          });
        }
      }
    );

    return options;
  }, [filterTagsData, isFilterTagsLoading]);

  const menuCategories: any = reastaurantData?.categoryTags.map(
    (value: any) => {
      return {
        value: capitalizeFirstLetter(value),
        label: capitalizeFirstLetter(value),
      };
    }
  ) || [{ value: "", label: "" }];

  const portionSizesOptions = portionSizesData.map((size) => ({
    value: size.portionSize,
    label: size.portionSize,
  }));

  const handleSelectPortion = (option: any) => {
    setPortionSize(option.value);

    if (option.value === portionSizesData[0].portionSize) {
      setValue("portionPrice", "0");
      setIsPortionPriceDisable(true);
    } else {
      setIsPortionPriceDisable(false);
    }
  };

  const { data: allergenData } = useGetAllergenInformationQuery();
  const allergenOptions =
    allergenData?.allergenInformation.map((allergen) => ({
      value: allergen.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(allergen.displayName)}
            alt={allergen.displayName}
            width="20px"
            height="20px"
          />
          {allergen.displayName}
        </div>
      ),
    })) || [];

  const foodAttributesOptions =
    foodAttributesData?.FoodAttributesList.map((attr) => ({
      value: attr.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(attr.displayName)}
            alt={attr.displayName}
            width="20px"
            height="20px"
          />
          {attr.displayName}
        </div>
      ),
    })) || [];

  useEffect(() => {
    if (RestID) {
      triggerGetMenuItemList({ restaurantId: RestID });
    }
  }, [RestID, triggerGetMenuItemList]);

  useEffect(() => {
    if (menuItemsData) {
      const options = menuItemsData.map((item: any) => ({
        value: item.itemId,
        displayName: item.displayName,
        label: (
          <div style={{ display: "flex", justifyContent: "left", gap: "5%" }}>
            <img
              src={item.imageUrl || DEFAULT_IMAGE_URL}
              alt=""
              width="30px"
              height="30px"
            />
            {item.displayName}
          </div>
        ),
        description: item.description,
        price: item.price,
        imageUrl: item.imageUrl,
      }));
      setAvailableOptions(options);
    }
  }, [menuItemsData]);

  const isPortionButtonDisabled = !portionSize || !portionPrice;

  // Handle menu creation
  const createSetMenuMutate = async (requestData: CreateSetMenuRequest) => {
    try {
      setIsSaving(true);
      const imageUrl = await uploadImage(uploadLogoFileExtetion, {
        fileExtention: uploadedImgDetails.fileExtention,
        formData: uploadedImgDetails.formData,
      });
      const response: any = await createSetMenu({
        ...requestData,
        imageReference: imageUrl,
        allergenInformation: requestData.allergenInformation,
        foodAttributes: requestData.foodAttributes,
        supportPortionSizes: requestData.supportPortionSizes,
        portions: requestData.portions,
        category: requestData.category,
        filterTags: requestData.filterTags,
        productId: requestData.productId,
        supportsPreOrdering: requestData.supportsPreOrdering,
      });
      if (
        response?.error?.status === 409 &&
        response?.error?.data === "ProductId Already exists"
      ) {
        toast.error("ProductId Already exists");
        setIsSaving(false);
      } else {
        toast.success("Combo Menu is created");
        setIsSaving(false);
        navigate("/productCatalogue/combo-menu");
      }
    } catch (error: any) {
      if (error.status === 409) {
        toast.error("Combo menu name is already exists");
      }
      toast.error("Something went wrong");
      setIsSaving(false);
    }
  };

// Handle form submission
const onSubmit = async (data: CreateSetMenuRequest) => {
  if (selectedItems.length === 0) {
    setErrorMessage("Cannot save without adding any menu items");
    return;
  }
  const structuredTags: { [key: string]: string[] } = {};

  // Loop through selected tags and group by category
  if (filterTagsData?.filterTags && data.filterTags) {
    Object.entries(filterTagsData.filterTags).forEach(
      ([categoryKey, categoryData]) => {
        const selectedTags = (data.filterTags ?? [])
          .map((tag: any) => tag.value)
          .filter((tagValue: string) =>
            (categoryData.tags as any[]).some(
              (tagObj) => tagObj.tag === tagValue
            )
          );

        if (selectedTags.length > 0) {
          structuredTags[categoryKey.toLowerCase()] = selectedTags.map(
            (tag: string) => tag.toLowerCase()
          );
        }
      }
    );
  }
  
  const object: any = {
    restaurantId: RestID,
    items: selectedItems.map((item) => ({
      menuItemId: item.value,
      description: item.description,
      imageUrl: item.imageUrl,
      displayName: item.displayName,
      price: item.price,
    })),
    description: data.description,
    displayName: data.displayName,
    abbreviation: data.abbreviation,
    category: data.category.value,
    imageReference: "",
    imageUrl: uploadedImgDetails.imgSrc,
    allergenInformation: data?.allergenInformation?.map(
      (item: any) => item.value
    ),
    foodAttributes: data?.foodAttributes?.map((item: any) => item.value),
    supportPortionSizes: canPortion,
    portions: portions.map((portion) => ({
      displayName: portion.size,
      additionalCost: portion.additionalCost,
    })),
    productId: data.productId,
    tags: structuredTags,
    supportsPreOrdering: data.supportsPreOrdering,
    ...(data.tinyId && !isNaN(Number(data.tinyId)) && Number(data.tinyId) > 0 
      ? { tinyId: Number(data.tinyId) } 
      : {})
  };
  
  createSetMenuMutate(object);
};

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtention: e.fileExtention,
    });
  };

  const handleAdd = () => {
    if (selectedOption) {
      const newItem = { ...selectedOption, quantity };
      setSelectedItems([...selectedItems, newItem]);
      setSelectedOption(null);
      setErrorMessage(null);
      setAvailableOptions(
        availableOptions.filter(
          (option: any) => option.value !== selectedOption.value
        )
      );
    } else {
      setErrorMessage("Please select an item to add.");
    }
  };

  const handleDelete = (index: number) => {
    const itemToRemove = selectedItems[index];
    const updatedItems = [...selectedItems];
    updatedItems.splice(index, 1);
    setSelectedItems(updatedItems);
    setAvailableOptions([...availableOptions, itemToRemove]);
  };

  const handleCheckboxChangeForPortion = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCanPortion(event.target.checked);
  };

  const addPortion = () => {
    const portionExists = portions.some(
      (portion) => portion.size === portionSize
    );

    if (portionExists) {
      setPortionErrorMessage("Portion size is already added.");
    } else {
      setPortions([
        ...portions,
        { size: portionSize, additionalCost: Number(portionPrice) },
      ]);
      setPortionSize("");
      setPortionPrice("");
      setValue("portionSize", "");
      setValue("portionPrice", "");
      setPortionErrorMessage(null);
    }
  };

  const deletePortion = (index: number) => {
    const updatedPortions = portions.filter((_, i) => i !== index);
    setPortions(updatedPortions);
    setPortionErrorMessage(null);
  };

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardHeader style={{ backgroundColor: "#fff" }}>
          <h4>Create Combo Menu</h4>
        </CardHeader>
        <CardBody>
          <form
            className="auth-login-form mt-3"
            onSubmit={handleSubmit(onSubmit)}
          >
            <IMGUploadComponent
              imageUrl={uploadedImgDetails.imgSrc}
              onUpload={imageUploadCallback}
            />
            <hr />
            <ControlledRowTextField
              label={"Combo Menu Name"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter Combo Menu Name"}
              isRequired={true}
              control={control}
              rules={{ required: "Combo Menu Name is required" }}
            />
            {errors.displayName && (
              <span className="text-danger">
                {errors.displayName.message as string}
              </span>
            )}
            <hr />
            <ControlledRowTextField
              label={"Abbreviation"}
              inputName={"abbreviation"}
              inputType={"text"}
              placeholder={"Enter Abbreviation"}
              control={control}
            />
            <hr />
            <ControlledRowTextField
              label={"Description"}
              inputName={"description"}
              inputType={"textarea"}
              placeholder={"Enter Description"}
              control={control}
              rules={{ required: "Combo Menu Description is required" }}
            />
            {errors.description && (
              <span className="text-danger">
                {errors.description.message as string}
              </span>
            )}
            <hr />
            <ControlledSelect
              label={"Category"}
              inputName={"category"}
              control={control}
              isMulti={false}
              optionsList={menuCategories}
              rules={{ required: "Category is required" }}
            />
            {errors.category && (
              <p className="text-danger">{errors.category.message as string}</p>
            )}
            <hr />
            <ControlledRowTextField
              label={"Product ID"}
              inputName={"productId"}
              inputType={"text"}
              placeholder={"Enter Product ID"}
              isRequired={true}
              control={control}
            />
            <hr />

            <ControlledRowTextField
              label={"Tiny ID"}
              inputName={"tinyId"}
              inputType={"number"}
              placeholder={"Enter Tiny ID (Optional)"}
              control={control}
             
            />

            <hr />
            <ControlledSelect
              label={"Allergic Infromation"}
              inputName={"allergenInformation"}
              control={control}
              isMulti={true}
              optionsList={allergenOptions}
            />

            <hr />
            <ControlledSelect
              label={"Food Attributes"}
              inputName={"foodAttributes"}
              control={control}
              isMulti={true}
              optionsList={foodAttributesOptions}
            />

            <hr />
            <ControlledSelect
              label={"Filter Tags"}
              inputName={"filterTags"}
              control={control}
              isMulti={true}
              optionsList={filterTagsOptions}
            />
            <hr />
            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="supportsPreOrdering"
                >
                  Supports Pre-Ordering
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="supportsPreOrdering"
                  checked={isPreOrder}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setIsPreOrder(event.target.checked);
                    setValue("supportsPreOrdering", event.target.checked);
                  }}
                />
              </Col>
            </Row>
            <hr />
            <Row className="mb-3">
              <Col lg={4}>
                <Label>Portion Available</Label>
              </Col>
              <Col lg={8}>
                <input
                  type="checkbox"
                  checked={canPortion}
                  className="form-check-input"
                  onChange={handleCheckboxChangeForPortion}
                />
                <hr />
                {canPortion && (
                  <div className="portion-section">
                    <div className="portion-inputs">
                      <Row>
                        <Col md={5} className="mt-1">
                          <ControlledRowSelectPortion
                            inputName="portionSize"
                            control={control}
                            optionsList={portionSizesOptions}
                            placeholder="Select portion size"
                            onChange={(option: any) =>
                              // setPortionSize(option ? option.value : "")
                              handleSelectPortion(option)
                            }
                          />
                          <br />
                        </Col>

                        <Col md={5}>
                          <ControlledRowTextFieldForPortion
                            inputName={"portionPrice"}
                            inputType={"number"}
                            placeholder={"Enter portion price"}
                            control={control}
                            isDisabled={isPortionPriceDisable}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              if (value >= 0) {
                                setPortionPrice(e.target.value);
                              } else {
                                setPortionPrice("");
                                setPortionErrorMessage(
                                  "Portion price cannot be negative."
                                );
                              }
                            }}
                            // onChange={(e) => setPortionPrice(e.target.value)}
                          />
                        </Col>

                        <Col md={2}>
                          <ButtonComponent
                            type="button"
                            titel="+Add"
                            isDisabled={
                              portionSizesData?.[0]?.portionSize === portionSize
                                ? false
                                : isPortionButtonDisabled
                            }
                            onClick={addPortion}
                          />
                        </Col>
                      </Row>
                    </div>
                    {portionErrorMessage && (
                      <div className="text-danger mt-2">
                        {portionErrorMessage}
                      </div>
                    )}
                    <Table>
                      <thead>
                        <tr>
                          <th>Size</th>
                          <th>Price</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {portions.map((portion, index) => (
                          <tr key={index}>
                            <td>{portion.size}</td>
                            <td>{portion.additionalCost}</td>
                            <td>
                              <Button
                                variant="light"
                                onClick={() => deletePortion(index)}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  title="Delete"
                                  color="#F24E1E"
                                />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Col>
            </Row>
          </form>
        </CardBody>
      </Card>
      <Card className="mt-3">
        <CardBody>
          <Row className="align-items-center mt-3">
            <Col sm={10}>
              <Select
                value={selectedOption}
                onChange={setSelectedOption}
                options={availableOptions}
                placeholder={isLoading ? "Loading..." : "Search menu item"}
                isSearchable
                isDisabled={!availableOptions}
                loadingMessage={() => "Loading menu items..."}
                noOptionsMessage={() =>
                  isLoading ? "Loading..." : "No items found"
                }
                filterOption={customFilterOption}
              />
            </Col>
            <Col sm={2} className="text-right">
              <ButtonComponent
                titel="+Add"
                type="button"
                onClick={handleAdd}
                isDisabled={!selectedOption}
              />
            </Col>
          </Row>
          <hr />
          <div className="selected-items-container">
            <h5>Selected Items</h5>
            <Table bordered className="mt-3" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Price (Rs.)</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.label}</td>
                    <td>{item.price}</td>
                    <td>
                      <Button
                        variant="light"
                        onClick={() => handleDelete(index)}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          title="Delete"
                          color="#F24E1E"
                        />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {errorMessage && (
              <div className="text-danger mt-2">{errorMessage}</div>
            )}
          </div>
        </CardBody>
      </Card>

      <div className="d-flex justify-content-end m-4">
        {isSaving ? (
          <ButtonComponent
            icon={<FontAwesomeIcon icon={faSpinner} spin />}
            titel="Saving..."
            isDisabled={true}
          />
        ) : (
          <ButtonComponent
            titel="Save"
            type="button"
            onClick={handleSubmit(onSubmit)}
          />
        )}
      </div>
    </>
  );
};

export default AddMenu;